import { Section14ClientRenewalModel } from 'bff';

export const matchesSearchCriteria = (client: Section14ClientRenewalModel, term: string) => {
  const searchTermLower = term.toLowerCase();
  const regex = wildcardToRegex(searchTermLower);

  if (regex.test(client.clientName.toLowerCase()) || regex.test(client.clientId.toString())) {
    return client;
  }

  const matchingInvestments = client.investments.filter(
    (inv) =>
      regex.test(inv.investmentNumber.toLowerCase()) || regex.test(inv.investmentName.toLowerCase())
  );

  if (matchingInvestments.length > 0) {
    return { ...client, investments: matchingInvestments };
  }

  return null;
};

const wildcardToRegex = (pattern: string): RegExp => {
  if (!pattern) return /.*/i;

  const escaped = pattern.replace(/([.+^=!:${}()|[\]/\\])/g, '\\$1');
  const regexString = escaped.replace(/\*/g, '.*').replace(/\?/g, '.');

  return new RegExp(regexString, 'i');
};
